/**
 * Created by falknisius on 19.05.17.
 */

import Reflux from 'reflux'
import themeStoreActions from './ThemeStoreActions'
import cssConstants from '../config/cssConstants.json'

class ThemeStore extends Reflux.Store {
  static id = 'themeStore'

  constructor () {
    super()
    // this.state = Object.assign({initialized: false, error: null, queryParams: null}, cssConstants)
    this.state = Object.assign({initialized: true, error: null, data: { groupName: ''}, queryParams: null, deviceUuid: null}, cssConstants)

    this.listenables = themeStoreActions
  }

  onFetchThemeCompleted (data) { // use the data here
    this._updateThemes(Object.assign({initialized: true, error: null, data: {groupName: data.data.groupName}}, data.data.theme))
  }

  onFetchThemeFailed (message) {
    console.error(message)
    this.setState({initialized: true, error: message.toString()})
  }

  _updateThemes (data) {
    let result = {}

    if (data) {
      let keyArray = Object.keys(data)
      if (keyArray && keyArray.length) {

        let self = this
        keyArray.forEach(function (key) {
          if (typeof data[key] === 'object' && data[key] !== null) {
            let subKeyArray = Object.keys(data[key])
            if (subKeyArray && subKeyArray.length) {
              let elements = data[key]
              if (subKeyArray.length === 1) {
                if (data.currentTheme && subKeyArray[0] === data.currentTheme) {
                  elements = data[key][data.currentTheme]
                }
              }
              if (self.state[key])
                result[key] = Object.assign({}, self.state[key], elements)
              else
                result[key] = Object.assign({}, elements)
            }
          } else {
            result[key] = data[key]
          }
        })

      }
      // if result is not empty set new State
      if (Object.keys(result).length) {
        this.setState(result)
      }
    }
  }

  onSetQueryParams (data) {
    this.setState({queryParams: data})
  }

  onSetDeviceUuid (uuid) {
    console.log('setting device uuid', uuid)
    this.setState({deviceUuid: uuid})
  }

}

let themeStore = Reflux.initStore(ThemeStore)

export default themeStore



// WEBPACK FOOTER //
// ./src/stores/ThemeStore.js